@file:OptIn(ExperimentalComposeUiApi::class)

package demos.`fun`

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.SizeTransform
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Slider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.blur
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.onPointerEvent
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.layout.SubcomposeLayout
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Constraints
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
//import io.kamel.image.KamelImage
//import io.kamel.image.asyncPainterResource

const val THREE_D_CAROUSEL = "6e3bbdf4e611521dc8a63e57888e6cc07483ca59ab9e0daf9e2567de434187b1"

val fakeDesertNames = listOf(
    "Mirage Sands",
    "Dustfall Dunes",
    "Barren Wastes",
    "Arid Expanse",
    "Whispering Dunes",
    "Forgotten Desert",
    "Silted Plains",
    "Sunscorch Plateau",
    "Solitude Desert",
    "Eternal Barrens",
    "Desolation Flats",
    "Quicksand Basin",
    "Lunar Dunes",
    "Tumbleweed Basin",
    "Ochre Plateau",
    "Rustling Sands",
    "Lost Horizon Desert",
    "Parched Wilds",
    "Sahara's Echo",
    "Nomad's Land"
)

@Composable
fun ThreeDCarousel() {

    Box(Modifier.background(color = Color(0xffebdeff)).fillMaxSize()) {

        var rot1 by remember { mutableStateOf(0f) }
        var rot2 by remember { mutableStateOf(0f) }

        var desertIndex by remember { mutableStateOf(-1) }

        AnimatedContent(
            targetState = desertIndex,
            transitionSpec = {

                val inverter = if (targetState > initialState) 1 else -1
                slideInVertically { -it * inverter } + fadeIn() togetherWith slideOutVertically { it * inverter } + fadeOut() using SizeTransform(
                    clip = false
                )
            },
            modifier = Modifier
                .padding(24.dp)
                .align(Alignment.TopCenter)


        ) {
            Text(
                fakeDesertNames.getOrElse(it) { "" },
                modifier = Modifier.fillMaxWidth(),
                textAlign = TextAlign.Center,
                fontWeight = FontWeight.Thin,
                fontSize = 24.sp,
                color = Color(0xff3d0a8a)
            )
        }


//        LazyRow (
//            Modifier.align(Alignment.Center)
//        ) {
//            items(fakeDesertNames.size) { i ->
//                LaunchedEffect(Unit) {
//                    println("new one here -> $i")
//                }
//
//                DessertCard(
//                    Modifier.graphicsLayer {
//                        rotationY = rot1
//                        translationX = -(rot2).dp.toPx() * i
//                    }
//                ) {
//                    desertIndex = i
//                }
//            }
//        }

        SubcomposeLayout(
            modifier = Modifier
                .fillMaxSize()
                .horizontalScroll(rememberScrollState())
        ) { constraints ->
            println("$constraints")
            val mainPlaceables = subcompose("") @Composable {
                for (i in 0..fakeDesertNames.lastIndex) {

                    LaunchedEffect(Unit) { println("new one here -> $i") }

                    DessertCard(
                        Modifier.graphicsLayer { rotationY = rot1 }
                    ) { desertIndex = i }

                }
            }.map {
                it.measure(Constraints())
            }

            val maxSize = mainPlaceables.fold(IntSize.Zero) { currentMax, placeable ->
                IntSize(
                    width = maxOf(currentMax.width, placeable.width),
                    height = maxOf(currentMax.height, placeable.height)
                )
            }

            val parentWidth = mainPlaceables.fold(0)
            { acc, it -> acc + it.width } - (rot2.toInt() * mainPlaceables.lastIndex)
            val maxHeight = mainPlaceables.maxOf { it.height }

            layout(parentWidth, constraints.maxHeight) {
                var xPosition = 0

                mainPlaceables.forEachIndexed { index, placeable ->
                    placeable.placeRelative(
                        x = xPosition - (rot2.toInt() * index),
                        y = (constraints.maxHeight / 2) - maxHeight / 2
                    )
                    xPosition += placeable.width
                }
            }
        }


//        Layout(
//            content = {
//                for (i in 0..fakeDesertNames.lastIndex) {
//                    DessertCard(
//                        Modifier.graphicsLayer {
//                            rotationY = rot1
//                        }
//                    ) {
//                        desertIndex = i
//                    }
//
//                }
//            },
//            modifier = Modifier
//                .align(Alignment.Center)
//                .horizontalScroll(rememberScrollState())
//        ) { measurables, constraints ->
//
//            val placeables = measurables.map { measurable ->
//                measurable.measure(constraints)
//            }
//
//            val parentWidth = placeables.fold(0)
//            { acc, it -> acc + it.width } - (rot2.toInt() * placeables.lastIndex)
//
//            layout(parentWidth, placeables.maxOf { it.height }) {
//                var xPosition = 0
//
//                placeables.forEachIndexed { index, placeable ->
//                    placeable.placeRelative(x = xPosition - (rot2.toInt() * index), y = 0)
//                    xPosition += placeable.width
//                }
//            }
//
//        }


//        Row(
//            Modifier
//                .horizontalScroll(rememberScrollState())
//                .padding(8.dp)
//                .padding(start = 100.dp)
//                .fillMaxSize(),
//            verticalAlignment = Alignment.CenterVertically,
//        ) {
//            for (i in 0..fakeDesertNames.lastIndex) {
//                DessertCard(
//                    Modifier.graphicsLayer {
//                        rotationY = rot1
//                        translationX = -(rot2).dp.toPx() * i
//                    }
//                ) {
//                    desertIndex = i
//                }
//
//            }
//        }

        Column(Modifier.align(Alignment.BottomCenter).width(200.dp)) {
            Slider(
                value = rot1,
                onValueChange = {
                    rot1 = it
                },
                valueRange = 0f..45f
            )
            Slider(
                value = rot2,
                onValueChange = {
                    rot2 = it
                },
                valueRange = -10f..50f
            )
        }
    }
}


@OptIn(ExperimentalComposeUiApi::class)
@Composable
fun DessertCard(
    modifier: Modifier = Modifier,
    onHovered: () -> Unit,
) {
    var isHovered by remember { mutableStateOf(false) }
    val scale by animateFloatAsState(
        targetValue = if (isHovered) 1.5f else 1f,
        animationSpec = spring(
            stiffness = Spring.StiffnessMediumLow,
        )
    )

    Box(
        modifier
            .graphicsLayer {
                transformOrigin = TransformOrigin(.5f, .8f)
                scaleX = scale
                scaleY = scale
            }
            .width(100.dp)
            .height(140.dp)
            .shadow(10.dp, RoundedCornerShape(20.dp))
            .background(Color.White, RoundedCornerShape(20.dp))
            .clip(RoundedCornerShape(20.dp))
            .onPointerEvent(PointerEventType.Enter) {
                isHovered = true
                onHovered()
            }
            .onPointerEvent(PointerEventType.Exit) {
                isHovered = false
            }
    ) {

//        KamelImage(
//            resource = asyncPainterResource("https://source.unsplash.com/random?desert,dune"),
//            contentDescription = null,
//            contentScale = ContentScale.Crop,
//        )

        Box(
            Modifier
                .blur(20.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                .align(Alignment.Center)
                .size(20.dp)
                .border(
                    2.dp,
                    color = Color(0x80000000),
                    shape = RoundedCornerShape(4.dp)
                )
        )

        Box(
            Modifier
                .align(Alignment.Center)
                .size(20.dp)
                .border(
                    2.dp,
                    color = Color(0xffffffff),
                    shape = RoundedCornerShape(4.dp)
                )
        )

    }
}

enum class SlotsEnum { Main, Dependent }
